const DATA = {
	GRAY: '#F5F5F7',
	WHITE: '#FFFFFF',
};

export default DATA;
